import { render, staticRenderFns } from "./InterfaceMessage.vue?vue&type=template&id=6a797b64"
import script from "./InterfaceMessage.vue?vue&type=script&lang=js"
export * from "./InterfaceMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports